import { gql } from "@apollo/client";

export const GET_FILES_BY_BELONGS_TO_QUERY = gql`
    query GetFilesByBelongsTo($belongsToType: BelongsToType!, $belongsToId: ID!) {
        getFilesByBelongsTo(
            belongsToType: $belongsToType
            belongsToId: $belongsToId
        ) {
            id
            file_name
            file_url
            mime_type
            file_size
            folder_id
            created_at
            created_by
            upload_status
        }
    }
`;

// Get File by ID Query

export const GET_FILE_QUERY = gql`
    query GetFile($id: ID!) {
        file(id: $id) {
            id
            file_name
            file_url
            mime_type
            file_size
            folder_id
            created_at
            created_by
            upload_status
        }
    }
`;

// Master Location Types Query

export const GET_DOCUMENT_INFORMATION_QUERY = gql`
  query GetDocumentInformation($input: GetDocumentInformationInput!) {
    getDocumentInformation(input: $input) {
      faq
      success
      message
    }
  }
`;

export const SEARCH_DOCUMENTS_QUERY = gql`
query SearchDocuments($input: SearchDocumentsInput!) {
    searchDocuments(input: $input) {
        totalCount
        items {
            id
            name
            mime_type
            size
            storage_path
            source
            tags
            document_type
            created_at
            regex {
                assetIds
                assetNames
                productTypes
                productCategories
                locationIds
                locationNames
                parentLocationIds
                parentLocationNames
                manufacturers
            }
            etl {
                status
                progress
                stage
                error
            }
        }
    }
}
`;

export const GET_DOCUMENT_TAGS_QUERY = gql`
  query GetDocumentTags($search: String, $assetIds: [ID!], $locationIds: [ID!]) {
    documentTags(search: $search, assetIds: $assetIds, locationIds: $locationIds)
  }
`;

export const GET_DOCUMENT_QUERY = gql`
  query GetDocument($id: ID!) {
    document(id: $id) {
      id
      name
      mime_type
      size
      storage_path
      source
      checksum
      tags
      document_type
      notes
      asset_text
      location_text
      created_at
      regex {
            assetIds
            assetNames
            unmappedAssetNames
            productTypes
            productCategories
            locationIds
            locationNames
            unmappedLocationNames
            manufacturers
            parentLocationIds
            parentLocationNames
            fedFromIds
            inspectionIds
            excludeAssetIds
            excludeLocationIds
        }
      etl {
        status
        progress
        stage
        processed_at
        error
      }
      extracted_data
    }
  }
`;
